<template>
  <Form @submit="onSubmit" :validation-schema="schema">
    <div class="spa">
      <div class="search">
        <div class="container">
          <div class="booking-container-n">
            <div class="row mb-5">
              <div class="col-xl-24 mb-3 text-center">
                <h3 class="form-group-title">When would you like to book?</h3>
              </div>
              <div class="col-24">
                <div class="row justify-content-center">
                  <div class="mb-3 col-20 col-lg-12 mb-lg-0">
                    <v-date-picker class="inline-block h-full" v-model="date" v-bind:min-date="minDate">
                      <template v-slot="{ inputValue, togglePopover }">
                        <div class="flex items-center" @click="togglePopover()">
                          <input v-bind:value="inputValue" class="form-control search-date calendar" readonly />
                        </div>
                      </template>
                    </v-date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-5">
              <div class="col-xl-24 mb-3 text-center">
                <h3>Number of guests:</h3>
              </div>

              <div class="col-xl-24 d-flex justify-content-center">
                <ul class="rad-btn-list">
                  <li>
                    <input id="rc1" type="radio" value="1" name="rc" v-model="guestCount" />
                    <label for="rc1">1</label>
                  </li>
                  <li>
                    <input id="rc2" type="radio" value="2" name="rc" v-model="guestCount" />
                    <label for="rc2">2</label>
                  </li>
                  <li>
                    <input id="rc3" type="radio" value="3" name="rc" v-model="guestCount" />
                    <label for="rc3">3</label>
                  </li>
                  <li>
                    <input id="rc4" type="radio" value="4" name="rc" v-model="guestCount" />
                    <label for="rc4">4</label>
                  </li>
                  <li>
                    <input id="rc5" type="radio" value="0" name="rc" v-model="guestCount" />
                    <label for="rc5">5+</label>
                  </li>
                </ul>
              </div>
            </div>

            <div class="row" v-if="guestCount == 0">
              <div class="col mb-5 d-flex justify-content-center">
                <div class="guests-exceeded">
                  <p>
                    For bookings of 4 guests or more please contact a member of the Spa team by calling
                    <a href="tel:01325729999">01325 729999</a> or click below to submit a spa booking
                    <a href="/spa-wellness/spa-enquiry/">enquiry</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="guestCount != 0">
            <div v-if="packagesLoading" class="d-flex justify-content-center">
              <loader></loader>
            </div>
            <div v-else>
              <div class="row mb-5">
                <div class="col-xl-24 mb-3 text-center">
                  <h3 class="form-group-title">Which spa day would you like to book?</h3>
                </div>
                <div class="col-24">
                  <div class="row justify-content-center">
                    <div class="col-24 col-md-12 col-xxl-8 mb-4" v-for="(spaDay, index) in setPackages">
                      <div
                        class="bg-white h-100 p-md-5 p-4 spa-day-item d-flex flex-column justify-content-between"
                        v-bind:class="{ 'spa-day-item--is-selected': isSpaDaySelected(spaDay) }"
                        v-on:click="onSelectSpaDay(spaDay)"
                      >
                        <div class="flex-grow">
                          <h4>{{ spaDay.DisplayName }}</h4>

                          <span class="spa-day-price"> &pound;{{ spaDay.bookingDetails.ActualPrice }}<span>/person</span> </span>

                          <div class="spa-day-body" v-html="spaDay.Description"></div>
                        </div>

                        <div class="btn btn--spa-day-toggle">
                          {{ !isSpaDaySelected(spaDay) ? "Select" : "Selected" }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--<div class="booking-container-n">
                <div class="row mb-5 justify-content-center">
                    <div class="col-24 col-md-16 ">
                        <div class="form-group">
                            <div class="title-wrapper">
                                <h3 class="form-group-title">Got a voucher?</h3>
                                <button class="help mb-2" type="button" v-on:click="onVoucherModalToggle()">Help</button>
                            </div>


                            <div class="row g-0">
                                <div class="col-xl-16">
                                    <input type="text" class="form-control" placeholder="Enter code" v-model="voucherCode" />
                                </div>

                                <div class="col-xl-8">
                                    <button class="btn btn--gold btn--block"
                                            v-bind:disabled="isCheckingCode"
                                            type="button" v-on:click="onCheckCode()">
                                        Apply code
                                    </button>

                                </div>
                            </div>


                        </div>
                    </div>

                </div>

            </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <actions-bar>
      <template v-slot:actions>
        <div class="row">
          <div class="col-12 d-flex justify-content-start">
            <button v-on:click="onBack" type="button" class="btn btn--transparent btn--back">Back</button>
          </div>
          <div class="col-12 d-flex justify-content-end" v-if="guestCount != 0">
            <button class="btn btn--slate-blue btn--continue" type="submit" v-bind:disabled="isContinueDisabled">Next</button>
          </div>
        </div>
      </template>
    </actions-bar>

    <standard-modal v-if="modalVouchersVisible" v-on:close="modalVouchersVisible = false">
      <template v-slot:header>
        <h2 class="mb-md-5 mb-3">How to use Voucher Codes</h2>
      </template>
      <template v-slot:body>
        <div class="row mb-md-5 mb-3" v-for="(giftVoucher, index) in content.giftVouchers" v-bind:key="index">
          <div class="col-md-8 d-flex justify-content-center mb-md-0 mb-3">
            <div v-if="giftVoucher.Image" class="voucher-code-image">
              <span class="has-bg-image bg-full" role="img" v-bind:style="{ backgroundImage: 'url(' + giftVoucher.Image.Path + ')' }"></span>
            </div>
          </div>
          <div class="col-md-16 col-sm-18 mx-md-0 mx-auto text-md-start text-center">
            <h3>
              {{ giftVoucher.Title }}
            </h3>
            <div class="dottedborder" v-html="giftVoucher.Body"></div>
          </div>
        </div>
      </template>
    </standard-modal>
  </Form>
</template>
<script>
import ActionsBar from "@/shared/components/ActionsBar.vue";
import StandardModal from "@/shared/components/StandardModal.vue";
import Cancel from "@/shared/components/Cancel.vue";
import { Field, Form, ErrorMessage } from "vee-validate";
import { store } from "../store/index";

import Loader from "@/shared/components/Loader.vue";
import moment from "moment";

import * as yup from "yup";
export default {
  name: "SpaDaySearch",
  components: {
    ActionsBar,
    Cancel,
    Field,
    Form,
    ErrorMessage,
    StandardModal,
    Loader,
  },
  mounted() {
    this.isLoading = true;

    this.guestCount = this.$route.query.guests || 2;
    this.selectedPackageId = this.$route.query.packageId;

    if (this.$route.query.d != null) {
      let innerDate = new Date(this.$route.query.d);
      let innerM = moment(innerDate);
      if (innerM.isAfter(moment())) {
        this.date = innerM.format("YYYY-MM-DD");
      } else {
        this.date = moment().add(1, "d").format("YYYY-MM-DD");
      }
    } else {
      this.date = moment().add(1, "d").format("YYYY-MM-DD");
    }

    this.minDate = moment().add(1, "d").format("YYYY-MM-DD");
    this.loadPackages();
  },
  computed: {
    session() {
      return store.getters.session;
    },
    configuration() {
      return store.getters.configuration;
    },
    content() {
      return this.configuration.Content.search;
    },
    isContinueDisabled() {
      return this.selectedSpaDay == null;
    },
  },
  data() {
    const schema = yup.object().shape({});
    return {
      schema,
      modalVouchersVisible: false,
      guestCount: 2,
      minDate: null,
      date: null,

      code: null,
      selectedSpaDay: null,
      packagesLoading: false,
      setPackages: [],
      voucherCode: null,
      vouchers: [],
      invalidVouchers: [],
      isCheckingCode: false,
      packageList: null,
      selectedPackageId: null,
    };
  },
  methods: {
    onCheckCode() {
      this.isCheckingCode = true;
      let o = this;
      let voucherDate = moment(this.date).format("YYYY-MM-DD");

      o.isCheckingCode = false;
    },

    loadPackages() {
      let o = this;
      o.packagesLoading = true;
      let payload = {
        /*            id: this.session.Id,*/
        item: {
          date: moment(this.date).format("YYYY-MM-DD"),
          numberOfClients: this.guestCount,
        },
      };

      store.dispatch("fetchPackages", payload).then((t) => {
        this.onSetPackages(t.packages);
        this.onSetPackageList(t.packageList);

        if (o.selectedPackageId != null) {
          var sP = o.setPackages.find((item) => item.PremierId == o.selectedPackageId);

          if (sP != null) {
            this.onSelectSpaDay(sP);
          }
        }

        this.trackSpaDayOptions();

        this.isLoading = false;
        o.packagesLoading = false;
      });
    },

    isSpaDaySelected(input) {
      return input == this.selectedSpaDay;
    },
    onSelectSpaDay(input) {
      this.selectedSpaDay = input;
    },
    onBack: function () {
      this.$router.push({
        name: "spa_type",
        params: { id: this.session.Id },
      });
    },
    onSubmit: function (values) {
      this.trackSelectedSpaDayOption(this.selectedSpaDay);
      store.dispatch("clear");

      var payload = {
        guestCount: this.guestCount,
        date: moment(this.date).format("YYYY-MM-DD"),
        spaDay: this.selectedSpaDay,
        spaDayDetail: this.packageList.find((item) => item.ID == this.selectedSpaDay.PremierId),
        code: this.code,
      };

      store.dispatch("createSession").then((response) => {
        var id = response.Id;

        store.dispatch("setSearch", payload).then(() => {
          this.$router.push({
            name: "spa_day_guests",
            params: { id: id },
          });
        });
      });
    },

    onSetPackageList(packageList) {
      this.packageList = packageList;
    },

    onSetPackages(packages) {
      var systemDays = this.configuration.SpaDays;

      var result = [];

      for (var sdi = 0; sdi < systemDays.length; sdi++) {
        var item = systemDays[sdi];

        var premierPackage = packages.find((p) => p.PackageID == +item.PremierId);
        if (premierPackage != null) {
          var bands = premierPackage.TimeBands.filter((tb) => tb.BandNumber == item.Band);
          premierPackage.TimeBands = bands;
          if (bands.length) {
            item.bookingDetails = premierPackage;
            result.push(item);
          }
        }
      }

      if (result.length == 1) {
        this.onSelectSpaDay(result);
      }

      this.setPackages = result;
    },

    onVoucherModalToggle: function () {
      this.modalVouchersVisible = !this.modalVouchersVisible;
    },

    trackSpaDayOptions() {
      if (this.$gtm.enabled()) {
        let items = [];
        for (let i = 0; i < this?.setPackages.length; i++) {
          let details = this.setPackages[i];
          let item = {
            item_id: details.PremierId,
            item_name: details.DisplayName,
            item_list_name: "Spa Day Options",
            price: details.bookingDetails.ActualPrice,
            item_category: "Spa Day ",
          };
          items.push(item);
        }
        window.dataLayer?.push({
          pageURL: "/spa/day/search",
          event: "view_item_list",
          ecommerce: {
            item_list_name: "Spa Day Options",
            items: items,
          },
        });
      }
    },

    trackSelectedSpaDayOption(spaOption) {
      if (this.$gtm.enabled()) {
        let item = {
          item_id: spaOption.PremierId,
          item_name: spaOption.DisplayName,
          item_list_name: "Spa Day Options",
          price: spaOption.bookingDetails.ActualPrice,
        };
        window.dataLayer?.push({
          pageURL: "/spa/day/search",
          event: "select_item",
          ecommerce: {
            item_list_name: "Spa Day Options",
            items: [item],
          },
        });
      }
    },
  },
  watch: {
    date(oldDate, newDate) {
      this.loadPackages();
    },
    guestCount(oldValue, newValue) {
      if (newValue > 0) {
        this.loadPackages();
      }
    },
  },
};
</script>
<style>
.vc-popover-content-wrapper {
  z-index: 1000 !important;
}

.spa-day-item {
  position: relative;
}

.spa-day-item h4 {
  font-size: 24px;
  max-width: 50%;
}

.spa-day-item .spa-day-price {
  font-size: 24px;
  font-weight: bold;
  position: absolute;
  top: 40px;
  right: 40px;
}

.spa-day-item .spa-day-body {
  margin-top: 20px;
}

.spa-day-item .spa-day-body p,
.spa-day-item .spa-day-body ul li {
  font-weight: 300;
}

.spa-day-item .spa-day-body ul li::marker {
  color: #a18f5b;
}

.spa-day-item .spa-day-price span {
  font-size: 18px;
  font-weight: 300;
}

.spa-day-item .btn {
  background-color: #eee9e7;
  padding: 15px;
  padding-left: 44px;
  position: relative;
  border: none;
}

.spa-day-item .btn:before,
.spa-day-item .btn:after {
  position: absolute;
  content: "";
  display: block;
  border-radius: 50%;
  z-index: 10;
}

.spa-day-item .btn:before {
  height: 24px;
  width: 24px;
  left: 10px;
  top: 10px;
  background: white;
}

.spa-day-item--is-selected {
  border: solid 2px #425260;
}

.spa-day-item--is-selected .btn {
  background-color: #425260;
  color: white;
}

.spa-day-item--is-selected .btn:after {
  height: 16px;
  width: 16px;
  left: 14px;
  top: 14px;
  background: #425260;
}

.voucher-code-image {
  position: relative;
  height: 196px;
  width: 251px;
}

@media (max-width: 575px) {
  .spa-day-item .spa-day-price {
    position: relative;
    top: unset;
    right: unset;
  }

  .spa-day-item h4 {
    max-width: unset;
  }
}

.guests-exceeded p {
  font-size: 18px;
  max-width: 600px;
  text-align: center;
}

.guests-exceeded a {
  font-weight: bold;
}
</style>
